import {loadStripe} from '@stripe/stripe-js';

let scrollIndicator = $('.scroll-indicator');

scrollIndicator.on('click', function () {
    // scroll to the second <li> in .gallery-list > li
    let target = $('.gallery-list > li').eq(1);

    // scroll the <dialiog> with class .gallery-dialog to the target
    let dialog = $('.gallery-list')[0];
    if (dialog) {
        dialog.scrollTo({
            top: target.offset().top - dialog.offsetTop - 150,
            behavior: 'smooth'
        });
    }
});

// if .gallery-list scrolls more than 100px, hide the scroll indicator
$('.gallery-list').on('scroll', function () {
    if ($(this).scrollTop() > 100) {
        scrollIndicator.fadeOut();
    } else {
        scrollIndicator.fadeIn();
    }
});

if($('.deposit-form-inner').length > 0) {

    const stripe = await loadStripe(window.st_pub_key),
        vehicleId = window.vehicle_id ? parseInt(window.vehicle_id) : null;

    let elements = null,
        paymentElement = null,
        addressElement = null,
        termsCheckbox = $('#deposit-terms'),
        reserveNextStepButton = $('#reserve-next-step'),
        hasStartedPaymentProcess = false;

    termsCheckbox.on('change', function() {
        if(!this.checked) {
            $('#submit').prop('disabled', true).addClass('disabled-button');
        } else {
            $('#submit').prop('disabled', false).removeClass('disabled-button');
        }
    });

    reserveNextStepButton.on('click', function() {
        const billingDetails = {
            name: document.getElementById('billing-name').value,
            email: document.getElementById('billing-email').value,
            phone: document.getElementById('billing-phone').value,
            address: {
                line1: document.getElementById('billing-address').value,
                city: document.getElementById('billing-city').value,
                state: document.getElementById('billing-state').value,
                postal_code: document.getElementById('billing-postal').value,
                country: document.getElementById('billing-country').value,
            }
        };

        if (!billingDetails.name || !billingDetails.email || !billingDetails.phone) {
            alert('Please fill in all required billing information');
            return;
        }

        if(!hasStartedPaymentProcess) {
            initPaymentProcess(billingDetails).then(() => {
                hasStartedPaymentProcess = true;
            });
        }
    });

    async function initPaymentProcess(billingDetails) {
        reserveNextStepButton.prop('disabled', true).addClass('disabled-button');
        reserveNextStepButton.text('Loading...');

        const formData = new FormData();
        formData.append('vehicle_id', vehicleId);
        formData.append('billing_details', JSON.stringify(billingDetails));

        const response = await fetch('/wp-admin/admin-ajax.php?action=create_payment_intent', {
            method: 'POST',
            body: formData,
        });

        const {clientSecret} = await response.json();

        const appearance = {
            theme: 'night',
            variables: {
                colorPrimary: '#ffb100',
                colorBackground: '#1a1a1a',
                colorText: '#ffffff',
                colorDanger: '#F23154',
            }
        };

        const options = {
            // layout: {
            //     type: 'tabs',
            //     defaultCollapsed: false,
            // },
            // payment_method_types: ['card'],
            // paymentMethodOrder: ['card'],
        };

        elements = stripe.elements({clientSecret, appearance});
        paymentElement = elements.create('payment', options);
        paymentElement.mount('#payment-element');
        $('.deposit-payment-step').slideDown();
        reserveNextStepButton.hide();
    }

    // Add submit button handler
    const submitButton = document.getElementById('submit');
    submitButton.addEventListener('click', async (e) => {
        e.preventDefault();

        const billingDetails = {
            name: document.getElementById('billing-name').value,
            email: document.getElementById('billing-email').value,
            phone: document.getElementById('billing-phone').value,
            address: {
                line1: document.getElementById('billing-address').value,
                city: document.getElementById('billing-city').value,
                state: document.getElementById('billing-state').value,
                postal_code: document.getElementById('billing-postal').value,
                country: document.getElementById('billing-country').value,
            }
        };

        if (!billingDetails.name || !billingDetails.email || !billingDetails.phone) {
            alert('Please fill in all required billing information');
            return;
        }

        submitButton.disabled = true;
        submitButton.textContent = 'Processing...';

        const {error} = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: window.location.origin + '/deposit-success/?vehicle_id=' + vehicleId,
                payment_method_data: {
                    billing_details: billingDetails
                }
            },
        });

        if (error) {
            alert('Payment failed: ' + error.message);
            submitButton.disabled = false;
            submitButton.textContent = 'Pay Now';
        }
    });

}
